module.exports = __webpack_public_path__ + "static/media/REA_Code-of-Conduct-2012-WEB.932465bf.pdf";